import AxiosPlugin from './plugins/axios';
import { PluginCRM, globalStore } from './main';
import { KCRM } from './sdk';
import { version } from '../package.json';

import * as kastBus from '../kastjs/event-bus';
import * as KastLCDP from '../kastjs/lcdp';
import * as KastUPM from '../kastjs/upm';
import * as KastMicroApp from '../kastjs/dolly';
import * as Radar from '../kastjs/radar';

const CRMPluginModule = {
  // 版本
  version,

  // 导出插件
  PluginCRM,
  AxiosPlugin,

  // 全局存储相关
  kastBus,
  globalStore,

  // lcdp 插件内部透传
  KastLCDP,

  // upm 插件内部透传
  KastUPM,

  // microApp 插件内部透传
  KastMicroApp,

  // 雷达 插件内部透传
  Radar,

  // 全局调用
  KCRM,
};

export { version };
export default CRMPluginModule;
